/* unplugin-vue-components disabled */import { render } from "./playerBack.vue?vue&type=template&id=93a85476&ts=true"
import script from "./playerBack.vue?vue&type=script&lang=ts&setup=true"
export * from "./playerBack.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/baseui/player/playerBack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93a85476"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93a85476', __exports__)) {
    console.log('reload')
    api.reload('93a85476', __exports__)
  }
  
  module.hot.accept("./playerBack.vue?vue&type=template&id=93a85476&ts=true", () => {
    console.log('re-render')
    api.rerender('93a85476', render)
  })

}


export default __exports__